import React from "react"
import ApplicationContainer from "components/ApplicationContainer"
import TapBar from "components/TapBar"
import AppBar from "components/AppBar"
import { useSelector } from "react-redux"
import * as practiceSelectors from "app/redux/practice/practice.selectors"
import { AppMain } from "../style"
import { useNavigationItems } from "./hooks"

interface IDefaultLayoutMobile {
  children?: React.ReactNode
  appBarComponent?: React.ComponentType
}
const DefaultLayoutMobile: React.FC<IDefaultLayoutMobile> = ({ children, appBarComponent: AppBarComponent }) => {
  const practice = useSelector(practiceSelectors.getPractice)
  const navigationItems = useNavigationItems("mobile")
  const practiceFeatures = practice?.features
  const nonFlaggedNavigationItems = navigationItems.filter(({ featureFlag }) => {
    if (featureFlag) return practiceFeatures?.[featureFlag]
    return true
  })
  return (
    <ApplicationContainer>
      {AppBarComponent ? <AppBarComponent /> : <AppBar />}
      <AppMain>{children}</AppMain>
      <TapBar mobileNavigationItems={nonFlaggedNavigationItems} />
    </ApplicationContainer>
  )
}

export default DefaultLayoutMobile
